<script lang="ts" setup>
  import { toRef, toRefs } from 'vue';
  import PhoneInput, { type PhoneInputProps } from './PhoneInput.vue';
  import { useField } from 'vee-validate';
  import { InputWidthVariant } from '../InputWrapper/';
  import type { FixedVueTelInputResponse } from './PhoneInput.types';

  export type PhoneInputFieldProps = PhoneInputProps & {
    rules?: (value: string) => string | boolean;
  };

  const props = withDefaults(defineProps<PhoneInputFieldProps>(), {
    value: undefined,
    rules: undefined,
    width: InputWidthVariant.FULL,
  });

  const emit = defineEmits<{
    'update:modelValue': [value: string, phoneObj: FixedVueTelInputResponse];
  }>();

  const {
    name: inputName,
    label,
    rules,
    ...rest
  } = toRefs<PhoneInputFieldProps>(props);
  // workaround to keep reactivity on rest value from toRefs
  const inputProps = toRef(rest);

  const {
    value: inputValue,
    errorMessage,
    handleBlur,
    handleChange,
    meta,
  } = useField<string>(inputName.value, rules?.value, {
    label: label?.value,
  });

  const updateValue = (value: string, phoneObj: FixedVueTelInputResponse) => {
    // here we should do something to validate the phone number with the internal validator of the library
    handleChange(value, true);
    emit('update:modelValue', value, phoneObj);
  };
</script>

<template>
  <PhoneInput
    v-bind="inputProps"
    :error="errorMessage as string"
    :label="label"
    :meta="meta"
    :loading="loading"
    :autofocus="autofocus"
    :model-value="inputValue"
    :name="name"
    :input-type="inputType"
    :placeholder="placeholder"
    :width="width"
    @blur="handleBlur"
    @update:modelValue="updateValue"
  >
    <template #iconRight> <slot name="iconRight"></slot> </template>
  </PhoneInput>
</template>
